import Connection from "../utils/Connection";
import { EXPRESS_URL } from "../utils/Macros";

export async function getDataBank(id: string, page: number  = 1) {
    return await Connection.get(`${EXPRESS_URL}databases/${id}?page=${page.toString()}`)
}